module.exports = __webpack_public_path__ + "img/b-doctor.1642569e.png";